import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, ViewChild } from '@angular/core';
import {
  MatOptionModule,
  provideNativeDateAdapter,
} from '@angular/material/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { RichTextEditorComponent } from '../../../components/shared/rich-textEditor/rich-textEditor.component';
import {
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatChipsModule } from '@angular/material/chips';
import { Router } from '@angular/router';
import { RfiWrapperComponent } from '../rfi-wrapper/rfi-wrapper.component';

@Component({
  selector: 'app-create-rfi',
  providers: [provideNativeDateAdapter()],
  standalone: true,
  imports: [
    CommonModule,
    MatFormFieldModule,
    MatIconModule,
    MatSelectModule,
    MatOptionModule,
    MatInputModule,
    RichTextEditorComponent,
    ReactiveFormsModule,
    MatDatepickerModule,
    MatChipsModule,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './create-rfi.component.html',
  styleUrl: './create-rfi.component.css',
})
export class CreateRfiComponent {
  @ViewChild(RfiWrapperComponent) tabWrapper!: RfiWrapperComponent;
  form: FormGroup;

  d_number: string[] = ['1', '2', '3'];
  code_cost: string[] = ['1', '2', '3'];

  rfi_management: string[] = [
    'Design Clarification',
    'Material Approval',
    'Construction Schedule',
    'Compliance Requirement',
    'Safety Concerns',
    'Technical Specification',
    'Other',
  ];

  constructor(private fb: FormBuilder, private router: Router) {
    this.form = this.fb.group({
      subject: ['', Validators.required],
      question: [''],
      file: [null],
      number: [''],
      due_date: [''],
      rfi_management: ['', Validators.required],
      received_form: [''],
      assignee: ['', Validators.required],
      distributed_list: [''],
      responsible_contractor: [''],
      spec_section: [''],
      location: ['', Validators.required],
      rfi_stage: [''],
      drawing_number: [''],
      cost_code: [''],
      schedule_impact: [''],
      cost_impact: [''],
      reference: [''],
    });
  }
  get questionControl() {
    return this.form.get('question');
  }

  onSubmit() {
    // throw new Error('Method not implemented.');
    this.navigateTo();
  }
  uploadedFiles: File[] = [];
  // Handle file input change
  onFileUpload(event: Event) {
    const input = event.target as HTMLInputElement;
    if (input.files) {
      this.uploadedFiles = Array.from(input.files);
    }
  }
  removeAssignee(assignee: string, controls: string[]) {
    controls.forEach((control) => {
      const assignees = this.form.get(control).value as string[];
      this.form.get(control).setValue(assignees.filter((a) => a !== assignee));
    });
  }
  navigateTo() {
    if (this.form.invalid) {
      this.form.markAllAsTouched(); // Highlight invalid fields
      console.log('Form is invalid:', this.form.invalid);
      return; // Stop navigation if form is invalid
    }

    console.log('Form is valid, navigating...');
    this.router.navigate(['/rfi-wrapper']);
  }

  close() {
    this.router.navigate(['/rfi-listing']);
  }
  removeItem(field: string, index: number) {
    const values = this.form.get(field)?.value;
    if (values && Array.isArray(values)) {
      values.splice(index, 1);
      this.form.get(field)?.setValue([...values]); // Update form field
    }
  }
}
